import { existsSync, mkdirSync, readFileSync, rmSync, writeFileSync } from 'node:fs';
import { dirname } from 'node:path';
import { credsPath } from './config.js';

/**
 * Stored CLI credentials. Phase 0/1 keeps the access token + the rotating refresh
 * cookie in a 0600 file. Phase 4 hardens this (OS keychain / encrypt-at-rest,
 * refresh-only) per docs/futurex/decisions.md (D4).
 */
export interface Credentials {
  apiUrl: string;
  email?: string;
  accessToken: string;
  refreshCookie?: string;
}

export function readCreds(): Credentials | null {
  const path = credsPath();
  if (!existsSync(path)) return null;
  try {
    return JSON.parse(readFileSync(path, 'utf8')) as Credentials;
  } catch {
    return null;
  }
}

export function writeCreds(creds: Credentials): void {
  const path = credsPath();
  mkdirSync(dirname(path), { recursive: true });
  writeFileSync(path, JSON.stringify(creds, null, 2), { mode: 0o600 });
}

export function clearCreds(): void {
  try {
    rmSync(credsPath(), { force: true });
  } catch {
    /* ignore */
  }
}
